type LabelLike = { classification: string; final_label: string };

/**
 * Vivid "highlighter" colour used for the emphasised label (chip + card ring).
 * Deliberately a single bold standout colour rather than the (often muted)
 * taxonomy member colour, so emphasised cards are unmistakable. Swap this one
 * constant to recolour the whole emphasis treatment (e.g. "#ef4444" red).
 */
export const EMPHASIS_HIGHLIGHT_COLOR = "#a3e635"; // lime-400

/** A single label is the emphasised one (exact match, so "non-boulder" never matches "boulder"). */
export const isEmphasisLabel = (
  label: LabelLike,
  emphasisLabel: string,
  emphasisEnabled: boolean,
): boolean =>
  emphasisEnabled &&
  !!emphasisLabel &&
  (label.final_label === emphasisLabel || label.classification === emphasisLabel);

/**
 * Returns the highlight colour for a card that carries the emphasised label,
 * else null. Always the vivid `EMPHASIS_HIGHLIGHT_COLOR` so the highlight pops.
 */
export const getCardEmphasisColor = (
  item: { labels?: LabelLike[] },
  emphasisLabel: string,
  emphasisEnabled: boolean,
): string | null => {
  if (!emphasisEnabled || !emphasisLabel) return null;
  const matches = item.labels?.some((l) =>
    isEmphasisLabel(l, emphasisLabel, emphasisEnabled),
  );
  return matches ? EMPHASIS_HIGHLIGHT_COLOR : null;
};
